window.addEventListener('DOMContentLoaded', () => {
    const voucherQuestionElements = document.querySelectorAll('button[data-voucher-question]');
    const voucherInputElements = document.querySelectorAll('div[data-voucher-input]');
    const voucherAddFormElements = document.querySelectorAll('form[data-voucher-add]');
    const voucherRemoveFormElement = document.querySelector('form[data-voucher-remove]');

    if (voucherQuestionElements) {
        voucherQuestionElements.forEach((element) => {
            element.onclick = () => {
                element.parentElement.classList.toggle('hidden');
                element.parentElement.nextElementSibling.classList.toggle('hidden');
                const input = element.parentElement.nextElementSibling.querySelector('input[name="voucherCode"]');

                setTimeout(() => {
                    if (input) {
                        input.focus();
                    }
                }, 0);
            };
        });
    }

    if (voucherInputElements) {
        voucherInputElements.forEach((element) => {
            element.querySelector('svg').onclick = () => {
                const inputWrapper = element.parentElement.parentElement;
                const questionWrapper = inputWrapper.previousElementSibling;
                const button = questionWrapper.querySelector('button[data-voucher-question]');
                inputWrapper.classList.toggle('hidden');
                questionWrapper.classList.toggle('hidden');

                if (button) {
                    setTimeout(() => button.focus(), 0);
                }
            };
            // element.querySelectorAll('svg')[1].onclick = () => {
            //     element.parentElement.parentElement.classList.toggle('hidden');
            //     element.parentElement.parentElement.previousElementSibling.classList.toggle('hidden');
            // };
        });
    }

    if (voucherAddFormElements) {
        voucherAddFormElements.forEach((element) => {
            element.addEventListener('submit', (event) => {
                event.preventDefault();
                const data = element.querySelector('input[name="voucherCode"]').value;
                if (data) {
                    document.querySelector('div#page_loader').style.display = 'flex';
                    let formData = new FormData();
                    formData.append('voucherCode', data);
                    fetch(element.action, {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: formData
                    }).then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error ${response.status}`);
                        }
                        return response.json();
                    }).then((responseData) => {
                        const responseMessageElement = element.querySelector('p[data-voucher="voucher_add_response_message"]');
                        responseMessageElement.parentElement.classList.remove('hidden');
                        switch (responseData.result) {
                            case 'error':
                                responseMessageElement.classList.add('msg-box', 'msg-box-error');
                                responseMessageElement.innerHTML = responseData.message;
                                break;
                            case 'success':
                                responseMessageElement.classList.add('msg-box', 'msg-box-success');
                                responseMessageElement.innerHTML = responseData.message;
                                window.location.reload();
                                break;
                            default:
                                responseMessageElement.classList.add('msg-box', 'msg-box-error');
                                responseMessageElement.innerHTML = 'There was an error applying your voucher, please try again later.';
                        }
                        document.querySelector('div#page_loader').style.display = 'none';
                        // eslint-disable-next-line no-console
                    }).catch(err => console.error('There was some trouble loading voucher: ', err));
                }
            });
        });
    }

    if (voucherRemoveFormElement) {
        voucherRemoveFormElement.addEventListener('submit', (event) => {
            event.preventDefault();
            document.querySelector('div#page_loader').style.display = 'flex';
            fetch(event.target.action, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            }).then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }
                return response.json();
            }).then((responseData) => {
                const responseMessageElement = document.querySelector('p[data-voucher="voucher_remove_response_message"]');
                responseMessageElement.parentElement.classList.add('hidden');
                switch (responseData.result) {
                    case 'error':
                        responseMessageElement.classList.add('msg-box', 'msg-box-error');
                        responseMessageElement.innerHTML = responseData.message;
                        break;
                    case 'success':
                        responseMessageElement.classList.add('msg-box', 'msg-box-success');
                        responseMessageElement.innerHTML = responseData.message;
                        window.location.reload();
                        break;
                    default:
                        responseMessageElement.classList.add('msg-box', 'msg-box-error');
                        responseMessageElement.innerHTML = 'There was an error applying your voucher, please try again later.';
                }
                document.querySelector('div#page_loader').style.display = 'none';
                // eslint-disable-next-line no-console
            }).catch(err => console.error('There was some trouble loading voucher: ', err));
        });
    }

});
